import { createSignal } from 'solid-js';
import { createMagicDoorContext } from '~/contexts/utils';
import { RentalApplicationGeneralSettingsRepository } from '~/repositories/settings/rentalApplicationGeneralSettingsRepository';

export const [RentalApplicationGeneralSettingsProvider, useRentalApplicationGeneralSettings] = createMagicDoorContext(
  'RentalApplicationGeneralSettings',
  () => {
    const repo = new RentalApplicationGeneralSettingsRepository();
    const [rentalApplicationGeneralSettings, setRentalApplicationGeneralSettings] = createSignal<any | undefined>(undefined);
    const [isLoading, setIsLoading] = createSignal<boolean>(false);
    const [error, setError] = createSignal<Error | undefined>(undefined);

    const getRentalApplicationGeneralSettings = async (): Promise<any | undefined> => {
      setIsLoading(true);
      try {
        const result = await repo.getRentalApplicationGeneralSettings();
        setRentalApplicationGeneralSettings(result);
        return result;
      } catch (err) {
        setError(err instanceof Error ? err : new Error(String(err)));
      } finally {
        setIsLoading(false);
      }
    };

    const updateRentalApplicationGeneralSettings = async (payload: any): Promise<any | undefined> => {
      setIsLoading(true);
      try {
        const result = await repo.updateRentalApplicationGeneralSettings(payload);
        setRentalApplicationGeneralSettings(result);
        return result;
      } catch (err) {
        setError(err instanceof Error ? err : new Error(String(err)));
        throw err;
      } finally {
        setIsLoading(false);
      }
    };

    return {
      isLoading,
      error,
      rentalApplicationGeneralSettings,
      getRentalApplicationGeneralSettings,
      updateRentalApplicationGeneralSettings,
    };
  }
);
